import { ElementType, HTMLProps, ReactNode } from 'react';
import { css } from '@emotion/react';

export interface StackProps extends HTMLProps<HTMLDivElement> {
  gap?: number | string;
  horizontal?: boolean;
  component?: ElementType;
  children: ReactNode;
}

export const Stack = ({ gap = 16, horizontal = false, component: Component = 'div', ...other }: StackProps) => (
  <Component className="stack" style={{ flexDirection: horizontal ? 'row' : 'column', gap }} {...other} css={stackStyle} />
);

const stackStyle = css`
  display: flex;

  > .divider {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
